(() => {
  if (customElements.get('product-stock-status')) {
    return;
  }

  class ProductStockStatus extends HTMLElement {
    connectedCallback() {
      this.stockWrap = this.querySelector('.stock-wrap');
      this.promoBanner = this.querySelector('[data-promo-banner]');
      this.variantJsonEl = document.querySelector('[data-current-variant-json]');

      this.refresh();

      if (this.variantJsonEl) {
        this.observer = new MutationObserver(() => this.onVariantChange());
        this.observer.observe(this.variantJsonEl, { childList: true, characterData: true, subtree: true });
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.abortController?.abort();
    }

    onVariantChange() {
      if (!this.variantJsonEl) return;

      try {
        const variant = JSON.parse(this.variantJsonEl.textContent);
        if (variant.sku) this.dataset.sku = variant.sku;
        if (variant.inventory_policy) this.dataset.inventoryPolicy = variant.inventory_policy;
        if (typeof variant.inventory_quantity === 'number') {
          this.dataset.inventoryQuantity = variant.inventory_quantity;
        }
        this.refresh();
      } catch {
        /* ignore malformed variant JSON */
      }
    }

    isShopifyInventorySku(sku) {
      return sku.startsWith('.');
    }

    renderShopifyInventory() {
      const quantity = Number(this.dataset.inventoryQuantity);
      if (Number.isNaN(quantity)) {
        this.hideStock();
        return;
      }

      this.renderStock(quantity);
    }

    async refresh() {
      const sku = this.dataset.sku;
      if (!sku || !this.stockWrap) return;

      if (this.isShopifyInventorySku(sku)) {
        this.abortController?.abort();
        this.renderShopifyInventory();
        return;
      }

      this.abortController?.abort();
      this.abortController = new AbortController();

      this.hideStock();

      try {
        const res = await fetch(`/a/cws/stock-status?sku=${encodeURIComponent(sku)}`, {
          signal: this.abortController.signal,
        });
        const data = await res.json();

        if (!data.success) {
          this.hideStock();
          return;
        }

        this.renderStock(data.available);
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.hideStock();
        }
      }
    }

    renderStock(available) {
      const quantity = Number(available);
      if (Number.isNaN(quantity)) {
        this.hideStock();
        return;
      }

      const policy = this.dataset.inventoryPolicy;
      const homeware = this.hasAttribute('data-homeware');
      const onlineOnly = this.hasAttribute('data-online-only');
      const labelEl = this.stockWrap.querySelector('.label');

      if (quantity > 2) {
        this.stockWrap.hidden = false;
        this.stockWrap.setAttribute('data-defaulStock', 'in-stock');
        labelEl.textContent = 'In Stock';
        this.togglePromo(true);
        return;
      }

      if (quantity > 0) {
        this.stockWrap.hidden = false;
        this.stockWrap.setAttribute('data-defaulStock', 'low-stock');
        labelEl.textContent = 'Low Stock';
        this.togglePromo(false);
        return;
      }

      if (policy === 'deny') {
        this.hideStock();
        return;
      }

      this.stockWrap.hidden = false;
      this.stockWrap.setAttribute('data-defaulStock', 'backorder');
      labelEl.textContent = homeware || onlineOnly ? 'Available to Order' : 'Pre-Order';
      this.togglePromo(false);
    }

    hideStock() {
      this.stockWrap.hidden = true;
      this.togglePromo(false);
    }

    togglePromo(show) {
      if (this.promoBanner) {
        this.promoBanner.hidden = !show;
      }
    }
  }

  customElements.define('product-stock-status', ProductStockStatus);
})();
